import { Card, Title1 } from "@fluentui/react-components";
import { ICompanyInfosInfo, SelectItem } from "library/types";
import FilterCurrency from "./FilterCurrency";
import FilterDate from "./FilterDate";
import FilterPackages from "./FilterPackages";
import FilterPaymentMethod from "./FilterPaymentMethod";
import FilterPaymentType from "./FilterPaymentType";
import { useTranslation } from "react-i18next";
import FilterPeriod from "./FilterPeriod";
import styled from "styled-components";
import SummaryCurrencyConverter from "../SummaryCurrencyConverter";
import { Dispatch } from "react";
import { SetStateAction } from "jotai";

interface Props {
  companyInfo?: ICompanyInfosInfo;
  defaultCompanyInfo?: ICompanyInfosInfo;
  setCompanyInfo: Dispatch<SetStateAction<ICompanyInfosInfo | undefined>>;
  convertCurrencyDisable: boolean;
  setConvertCurrencyDisabled: Dispatch<SetStateAction<boolean>>;
  selectedCurrencyToConvert: SelectItem | null;
  setSelectedCurrencyToConvert: Dispatch<SetStateAction<SelectItem | null>>;
  isLoading: boolean;
  countryCode?: number;
  defaultCurrencyByUserCountry?: SelectItem | null;
}
const FilterSection = ({
  companyInfo,
  setCompanyInfo,
  defaultCompanyInfo,
  convertCurrencyDisable,
  setConvertCurrencyDisabled,
  selectedCurrencyToConvert,
  setSelectedCurrencyToConvert,
  isLoading,
  countryCode,
  defaultCurrencyByUserCountry,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Container>
      <Card style={{ padding: "20px" }}>
        <Title1>{t("hbh.filters.label")}</Title1>
        <FilterPeriod companyInfo={companyInfo} />
        <FilterPackages companyInfo={companyInfo} isLoading={isLoading} />
        <FilterCurrency companyInfo={companyInfo} countryCode={countryCode} />
        {defaultCompanyInfo && (
          <SummaryCurrencyConverter
            defaultCurrencyByUserCountry={defaultCurrencyByUserCountry}
            selectedCurrency={selectedCurrencyToConvert}
            setSelectedCurrency={setSelectedCurrencyToConvert}
            defaultCompanyInfo={defaultCompanyInfo}
            setCompanyInfo={setCompanyInfo}
            convertCurrencyDisable={convertCurrencyDisable}
            setConvertCurrencyDisabled={setConvertCurrencyDisabled}
          />
        )}
        <FilterPaymentType />
        <FilterPaymentMethod />
        <FilterDate />
      </Card>
    </Container>
  );
};

export default FilterSection;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
